import { Goals } from "../data/models/Goals";
import { getLogger } from "../utils/logging";

const { log, warn } = getLogger('GoalHelper', { color: 'green', enabled: false });

/**
 * @description A helping class for the current user/account session, which maintains account goals and listens for changes.
 * @export
 * @class GoalHelper
 */
export class GoalHelper {

    goals: Goals; // current account goals

    constructor(goals?) {
        log(`GoalHelper.`)

        this.loadGoals(goals);

        // todo: listen for account/goal changes and update here.
        // EventService.subscribe(AppEvents.ACCOUNT_UPDATED, async (e) => {
        //     this.onAccountUpdate(e.target);
        // });
    }

    loadGoals = (account) => {
        this.goals = new Goals(account?.metadata?.goals);
        return this.goals;
    }

    // Returns the current standard Goals for the current user, or otherwise the one passed in.
    getGoals = (account?) => {
        // if another account is passed in for some reason, initialize new goals with it.
        let goals = !account ? this.goals : new Goals(account.goals?.metadata);
        return goals.getGoals();
    }

    getGoal = (goal) => {
        return this.goals.getGoal(goal);
    }

    setGoal = (goal, value) => {
        this.goals.setGoal(goal, value);
        return this.goals;
    }

    onAccountUpdate = (target) => {
        log(`🙌 Account changed, reload goals`, target);
    }

    // just returns a new empty, "standard" goals object
    makeNewGoals = () => {
        let goals = new Goals();
        return goals.getGoals();
    }

}

export default new GoalHelper();
